// Bridges ui.ts's cast handler to GameScene for a Bind·Charge cast -- strings
// a conductive link between the faced object and the marked Source (or the
// caster, if nothing is marked). The conduction itself isn't triggered from
// here: it lives in rune-lab/src/sim/chargeBind.ts's settleChargeBind, which
// runs as a settle system on every world mutation -- so it has already
// equalized both loci (and opened anything the far end feeds) by the time the
// cast returns. See ChargeBindDef in rune-lab/src/sim/types.ts for the full
// mechanic, including the resistive-loss tax on the caster.
//
// The event/result shapes themselves live in rune-lab/src/sim/casts.ts with the
// handler that consumes them, and are re-exported here unchanged, so every
// import site reads them from this module -- the same shape every other
// operator effect's bridge already has.
import { ChargeBindEffectEvent, ChargeBindEffectResult } from '../../rune-lab/src/sim/casts';

export type { ChargeBindEffectEvent, ChargeBindEffectResult };

type Handler = (event: ChargeBindEffectEvent) => ChargeBindEffectResult;

let handler: Handler | null = null;

export function onChargeBindEffect(fn: Handler): void {
  handler = fn;
}

export function triggerChargeBindEffect(event: ChargeBindEffectEvent): ChargeBindEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '', sourceWasSelf: true };
}
